import React from "react";
import Drop from "react-dropdown-aria";
import "../dropDown/dropDown.css";
import "./../inputReport/inputReport.css";
import styles, { styleFilter } from "./../custonStyles/custonStyles";

export default class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  } 

  setValue = (selectedOption) => {
    this.setState({ value: selectedOption });
    this.props.parentCallback(selectedOption);
  };

  render() {
    return (
      <>
        {this.props.filter ? (
            <div className="list_">
              <Drop
                id='drop'
                placeholder={this.props.name}
                height={this.props.height}
                width={this.props.width}
                style={styleFilter}
                options={this.props.arrayItens}
                setSelected={this.setValue}
              />
            </div>

        ) : this.props.dropReportFilter ? (
          <div className="insideContainer">
            <div>
              <strong>{this.props.title}:</strong>
            </div>
            <Drop
              id='drop'
              placeholder="Selecione..."
              maxContentHeight={300}
              height={this.props.height}
              width={this.props.width}
              style={styles}
              options={this.props.arrayItens}
              setSelected={this.setValue}
            />
          </div>
        ) : (
          <div className="Entrada">
            <div>
              <label className="Label">
                <strong>{this.props.title}</strong>
              </label>
            </div>
            <div className="list_">
              <Drop
                id='drop'
                placeholder="Selecione..."
                maxContentHeight={300}
                height={this.props.height}
                width={this.props.width}
                style={styles}
                options={this.props.arrayItens}
                setSelected={this.setValue}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}